import { Check, X, Sparkles } from 'lucide-react';

const ROWS = [
  { feature: 'Get started time', diy: '2\u20134 weeks setup', us: 'Under 2 minutes', usWin: true },
  { feature: 'Full-stack code (React + FastAPI + MongoDB)', diy: 'Write it yourself', us: 'Generated in seconds', usWin: true },
  { feature: 'AI model access (Claude, GPT, Gemini)', diy: '3 separate keys + integration', us: 'Included, auto-routed', usWin: true },
  { feature: 'Managed database', diy: '$25\u2013$200/mo MongoDB Atlas', us: 'Included in plan', usWin: true },
  { feature: 'Payment processing (Stripe)', diy: '2\u20134 days integration', us: 'One-click connect', usWin: true },
  { feature: 'Google / Apple / GitHub Auth', diy: '1\u20132 days per provider', us: 'Prebuilt', usWin: true },
  { feature: 'Image generation (Nano Banana / GPT-Image)', diy: 'Manual API calls', us: 'Native in every conversation', usWin: true },
  { feature: 'Global deploy + custom domain + SSL', diy: 'Days of config on AWS / GCP', us: '10 minutes', usWin: true },
  { feature: 'GitHub sync (own your code)', diy: 'Yes', us: 'Yes \u2014 always portable', usWin: null },
  { feature: 'Monthly infrastructure bill', diy: '$400\u2013$2,500', us: 'From $20', usWin: true },
  { feature: 'Engineer required', diy: '1\u20135 full-time hires', us: 'Zero. Just you and the AI.', usWin: true },
];

export default function Comparison() {
  return (
    <section
      id="compare"
      className="relative py-24 md:py-28 text-white"
      style={{
        background:
          'radial-gradient(900px 500px at 80% 30%, rgba(0,240,255,0.08) 0%, transparent 60%),' +
          'linear-gradient(180deg, #000 0%, #030303 100%)',
      }}
    >
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto">
          <div className="inline-flex items-center gap-2 text-[10px] tracking-[0.4em] text-[#00F0FF] font-semibold uppercase mb-4 font-mono">
            <Sparkles size={12} />
            The comparison you were looking for
          </div>
          <h2 className="font-display text-4xl md:text-6xl font-black tracking-[-0.03em] text-white">
            DIY stack vs{' '}
            <span className="italic bg-clip-text text-transparent bg-gradient-to-r from-[#00F0FF] to-[#FF007F]">
              Around the World AI
            </span>
          </h2>
          <p className="mt-5 text-white/60 text-lg leading-relaxed">
            The honest breakdown of what it takes to run this platform yourself
            &mdash; versus letting us do it for you.
          </p>
        </div>

        <div className="mt-14 rounded-2xl overflow-hidden glass shadow-[0_25px_80px_-30px_rgba(0,0,0,0.6)]">
          {/* Header */}
          <div className="grid grid-cols-12 bg-black/60 text-white text-[13px] font-bold">
            <div className="col-span-6 md:col-span-5 px-5 py-4">Capability</div>
            <div className="col-span-3 md:col-span-3 px-5 py-4 border-l border-white/10 text-center text-white/60">
              DIY tech stack
            </div>
            <div className="col-span-3 md:col-span-4 px-5 py-4 border-l border-white/10 bg-gradient-to-r from-[#00F0FF] to-[#FF007F] text-black text-center flex items-center justify-center gap-1.5 font-black">
              <Sparkles size={14} /> Around the World AI
            </div>
          </div>

          {/* Rows */}
          {ROWS.map((r, i) => (
            <div
              key={r.feature}
              className={`grid grid-cols-12 items-center text-sm ${
                i % 2 === 0 ? 'bg-white/[0.02]' : 'bg-transparent'
              }`}
            >
              <div className="col-span-6 md:col-span-5 px-5 py-4 text-white/90 font-medium">
                {r.feature}
              </div>
              <div className="col-span-3 md:col-span-3 px-5 py-4 border-l border-white/8 text-center">
                <div className="flex items-center justify-center gap-1.5 text-white/50">
                  {r.usWin === true && <X size={14} className="text-rose-400" />}
                  <span className="text-[13px]">{r.diy}</span>
                </div>
              </div>
              <div className="col-span-3 md:col-span-4 px-5 py-4 border-l border-white/8 bg-[#00F0FF]/5 text-center">
                <div className="flex items-center justify-center gap-1.5 text-white font-semibold">
                  <Check size={16} className="text-[#00F0FF]" />
                  <span className="text-[13px]">{r.us}</span>
                </div>
              </div>
            </div>
          ))}

          {/* Footer bar */}
          <div className="grid grid-cols-12 border-t border-white/10 bg-black/60 text-white">
            <div className="col-span-6 md:col-span-5 px-5 py-5 font-bold">
              Bottom line
            </div>
            <div className="col-span-3 md:col-span-3 px-5 py-5 border-l border-white/10 text-center">
              <div className="text-rose-300 font-bold text-[15px]">$800&ndash;$2,500/mo</div>
              <div className="text-white/45 text-[11px]">+ weeks of engineering</div>
            </div>
            <div className="col-span-3 md:col-span-4 px-5 py-5 border-l border-white/10 bg-gradient-to-r from-[#00F0FF]/10 to-[#FF007F]/10 text-center">
              <div className="font-display text-[15px] font-black bg-clip-text text-transparent bg-gradient-to-r from-[#00F0FF] to-[#FF007F]">
                From $20/mo
              </div>
              <div className="text-white/70 text-[11px]">+ zero engineering</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
